import { NavLink } from 'react-router';

/**
 * Sub-nav for the org settings cluster (/app/settings/*). Adds horizontal
 * tabs for the different settings sections so they don't have to share the
 * top-level nav. Mirrors AdminSubNav in styling.
 *
 * Current tabs:
 *   - Team (members + invites)
 *   - Meta Pixel (Conversions API config — Pro+ feature)
 */
export function SettingsSubNav() {
  return (
    <nav className="-mt-2 mb-6 flex flex-wrap items-center gap-1 text-xs">
      <SubTab to="/app/settings/members">Team</SubTab>
      <SubTab to="/app/settings/pixel">Meta Pixel</SubTab>
    </nav>
  );
}

function SubTab({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `rounded-full px-3 py-1 font-medium transition ${
          isActive
            ? 'bg-[var(--color-primary)] text-[var(--color-primary-foreground)]'
            : 'text-[var(--color-on-surface-variant)] hover:bg-[var(--surface-glass)] hover:text-[var(--color-foreground)]'
        }`
      }
    >
      {children}
    </NavLink>
  );
}
